import { DataGrid, Spinner } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { C2EddyCandidateListResponse } from '@/entities/integrations';
import { dataGridHeightByRows } from '@/shared/lib';

import { useC2EddyCandidateColumns } from './useC2EddyCandidateColumns';

/** Потолок превью в карточке: страница целиком выше — остаток прокручивается внутри самого грида */
const PREVIEW_MAX_HEIGHT = 480;

type Props = {
  data: C2EddyCandidateListResponse | undefined;
  isLoading: boolean;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
};

/**
 * Превью закрытых обращений найденного периода: сколько их всего и постраничный список.
 * Загружать по нему нечего — загрузка берёт период целиком.
 */
export const C2EddyCandidatesPreview: FC<Props> = ({ data, isLoading, page, pageSize, onPageChange }) => {
  const { t } = useTranslation(['integrations']);
  const columns = useC2EddyCandidateColumns();

  const items = data?.items ?? [];

  return (
    <div className="flex flex-col gap-3">
      {data && <p className="font-medium">{t('integrations:c2Eddy.candidates.found', { count: data.total })}</p>}
      <DataGrid
        className="w-full"
        columns={columns}
        dataSource={{
          mode: 'paginated',
          totalCount: data?.total ?? 0,
          page,
          pageSize,
          onPageChange,
          data: items,
        }}
        getRowId={(row) => String(row.eddyTicketId)}
        height={dataGridHeightByRows(items.length, PREVIEW_MAX_HEIGHT)}
        emptyState={
          isLoading ? (
            <Spinner className="size-6" />
          ) : (
            <span className="text-muted-foreground">{t('integrations:c2Eddy.candidates.empty')}</span>
          )
        }
        ariaLabel={t('integrations:c2Eddy.candidates.ariaLabel')}
      />
    </div>
  );
};
